import React from 'react';
import parse from 'html-react-parser';
import { classNames } from '../helpers/classes';
import StyledImage from './StyledImage';
import logoJeepXtream from '../public/img/logo-jeep-xtreme.png';

export default function CategoryImage({
  title,
  description,
  image,
  textRight,
  textLeft,
  fullHeight,
  extreme = false
}: {
  title: string;
  description: string;
  image: string;
  textRight?: boolean;
  textLeft?: boolean;
  fullHeight?: boolean;
  extreme?: boolean;
}) {
  let divClass = 'mx-auto sm:w-2/5 top-16';
  let h1Class = 'text-center';
  let pClass = 'text-justify';
  if (textRight) {
    divClass = 'transform sm:w-1/3 mx-auto sm:mx-0 sm:right-40 sm:left-auto';
    h1Class = 'text-center sm:text-right';
    pClass = 'text-center sm:text-justify';
  }
  if (textLeft) {
    divClass = 'transform sm:w-1/3 mx-auto sm:mx-0 sm:left-40 sm:right-auto';
    h1Class = 'text-center sm:text-left';
    pClass = 'text-center sm:text-justify';
  }

  return (
    <div
      className={classNames(
        fullHeight ? 'h-full' : 'min-h-screen',
        'w-full -mb-1.5 relative'
      )}
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})`,
        backgroundPosition: 'bottom center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div
        className={`absolute flex flex-col lg:py-16 py-10 z-10 w-10/12  right-0 bottom-0 left-0 ${divClass}`}
      >
        {extreme ? (
          <div className="text-center mb-4">
            <StyledImage src={logoJeepXtream} alt="Xtreme badge" />
          </div>
        ) : (
          <h1
            className={`text-white font-bold text-4xl sm:text-5xl mb-10 ${h1Class}`}
          >
            {parse(title)}
          </h1>
        )}

        <p className={`text-white font-normal leading-normal ${pClass}`}>
          {parse(description)}
        </p>
      </div>
      <div className="absolute hidden lg:block w-full h-full bg-black bg-opacity-10"></div>
      {fullHeight && (
        <img
          src={image}
          alt={`${title} category`}
          className="w-full hidden lg:block"
        />
      )}
    </div>
  );
}
